export default function TranslatorService($http, $q, API) {
  'ngInject'

  function translateText(q, glossaryId) {
    var defer = $q.defer()

    // var url = API.TRANSLATOR_API + 'api/translate/qp2'

    // var token
    // if (API.TRANSLATOR_API.indexOf('translator-dev') !== -1) {
    //   token =
    //     'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MTMyMDEsImlzcyI6InF1aWRkIiwicm9sZXMiOlsidXNlciJdLCJ1c2VyIjoyNjMxNjd9.3kkZLuyjEynrCGKjYu4WphGELmQGAyR0BVkN8JpHu7E'
    // } else {
    //   token =
    //     'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE4MzU5ODAwNjUsImlzcyI6InF1aWRkIiwicm9sZXMiOlsidXNlciJdLCJ1c2VyIjo0NDU0OTI0fQ.LaeJ0yn2DHJQD84nwr7dwBob-OwlhSF1gWoB7sqdsok'
    // }

    // $http
    //   .post(
    //     url,
    //     {
    //       text: q,
    //       target_language: ['zh', 'zh-TW', 'ja', 'ko'],
    //       glossary: !glossaryId ? null : glossaryId,
    //     },
    //     {
    //       headers: {
    //         'X-Collectible-Platform': 'Script',
    //         Authorization: token,
    //         'Content-Type': 'application/json',
    //       },
    //     },
    //   )
    //   .success(defer.resolve)
    //   .error(defer.reject)

    // change to fake defer resolve always
    defer.resolve() // change to fake defer resolve always

    return defer.promise
  }

  function translateOfferAllLanguage(t, txt, txt_t, txt_btn) {
    var defer = $q.defer()

    var promises = {
      t: translateText(t),
    }

    if (txt) {
      promises = _.merge(promises, {
        txt: translateText(txt),
      })
    }
    if (txt_t) {
      promises = _.merge(promises, {
        txt_t: translateText(txt_t),
      })
    }
    if (txt_btn) {
      promises = _.merge(promises, {
        txt_btn: translateText(txt_btn),
      })
    }

    $q.all(promises).then(defer.resolve).catch(defer.reject)

    return defer.promise
  }

  function translateProductAllLanguage(t, txt, glossaryId) {
    var defer = $q.defer()

    var promises = {
      t: translateText(t, glossaryId),
      txt: translateText(txt, glossaryId),
    }

    $q.all(promises).then(defer.resolve).catch(defer.reject)

    return defer.promise
  }

  function translateChecklist(line1, line2, glossaryId) {
    var defer = $q.defer()

    var promises = {
      t: translateText(line1, glossaryId),
    }

    if (line2) {
      promises = _.merge(promises, {
        txt: translateText(line2, glossaryId),
      })
    }

    $q.all(promises).then(defer.resolve).catch(defer.reject)

    return defer.promise
  }

  function translateChannelAllLanguage(t, txt, sht, txt_wel, glossaryId) {
    var defer = $q.defer()

    var promises = {
      t: translateText(t, glossaryId),
    }

    if (txt) {
      promises = _.merge(promises, {
        txt: translateText(txt, glossaryId),
      })
    }
    if (sht) {
      promises = _.merge(promises, {
        sht: translateText(sht, glossaryId),
      })
    }
    if (txt_wel) {
      promises = _.merge(promises, {
        txt_wel: translateText(txt_wel, glossaryId),
      })
    }

    $q.all(promises).then(defer.resolve).catch(defer.reject)

    return defer.promise
  }

  function translateDropAllLanguage(t, txt, glossaryId) {
    var defer = $q.defer()

    var promises = {
      t: translateText(t, glossaryId),
    }

    if (txt) {
      promises = _.merge(promises, {
        txt: translateText(txt, glossaryId),
      })
    }

    $q.all(promises).then(defer.resolve).catch(defer.reject)

    return defer.promise
  }

  function uploadGlossary(channelId, model) {
    var defer = $q.defer()
    var url = API.TRANSLATOR_API + 'api/channels/' + channelId + '/glossary'

    // var token
    // if (API.TRANSLATOR_API.indexOf('translator-dev') !== -1) {
    //   token =
    //     'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2Nzg4MTMyMDEsImlzcyI6InF1aWRkIiwicm9sZXMiOlsidXNlciJdLCJ1c2VyIjoyNjMxNjd9.3kkZLuyjEynrCGKjYu4WphGELmQGAyR0BVkN8JpHu7E'
    // } else {
    //   token =
    //     'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE4MzU5ODAwNjUsImlzcyI6InF1aWRkIiwicm9sZXMiOlsidXNlciJdLCJ1c2VyIjo0NDU0OTI0fQ.LaeJ0yn2DHJQD84nwr7dwBob-OwlhSF1gWoB7sqdsok'
    // }

    // $http
    //   .post(
    //     url,
    //     { result: model },
    //     {
    //       headers: {
    //         'X-Collectible-Platform': 'Script',
    //         Authorization: token,
    //         'Content-Type': 'application/json',
    //       },
    //     },
    //   )
    //   .success(defer.resolve)
    //   .error(defer.reject)

    defer.resolve() // change to fake defer resolve always

    return defer.promise
  }

  return {
    translateText: translateText,
    translateOfferAllLanguage: translateOfferAllLanguage,
    translateProductAllLanguage: translateProductAllLanguage,
    translateChannelAllLanguage: translateChannelAllLanguage,
    uploadGlossary: uploadGlossary,
    translateChecklist: translateChecklist,
    translateDropAllLanguage,
  }
}
